import SendReceipt from './sendReceipt';

export default SendReceipt;
